import React from "react";
import WarningIcon from "../../assets/media/articles/danger.png";

const $ = window.$;

export default function ConfirmationModal({
  title,
  id,
  onClick,
  hex,
  white,
  classNames,
}) {
  const closeModal = () => $(`#${id}`).modal("hide");
  return (
    <div
      className="modal fade"
      id={id}
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-body pb-1">
            <button
              type="button"
              className="close"
              aria-label="Close"
              onClick={closeModal}
              style={{ outline: "none" }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <center>
              <img
                alt="warning"
                src={WarningIcon}
                style={{ width: "50px", marginBottom: 12 }}
              />
              <h4 style={{ fontSize: 18 }}>
                {title}
                <br />
                You won't be able to restore the data.
              </h4>
            </center>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "10px",
              }}
            >
              <button
                type="button"
                className={`btn btn-white ${classNames}`}
                onClick={() => {
                  onClick();
                  closeModal();
                }}
              >
                Yes
              </button>
              <button
                type="button"
                className="btn btn-white"
                style={{
                  backgroundColor: hex || "white",
                  color: white ? "white" : "black",
                  marginLeft: 5,
                }}
                onClick={closeModal}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/ConfirmationModal/index.js